import React from 'react';

export const FetchJobsContext = React.createContext<{
    fetchSchedulesAndWarnings: any;
    refreshJobs: any;
}>({
    fetchSchedulesAndWarnings: () => {},
    refreshJobs: () => {},
});
